




import { defineComponent } from "@vue/composition-api";
import { mapActions, mapGetters } from "vuex";
import { tableHeaders } from "@monorepo/utils/src/variables/projectsData/InformationSecurityJournal/tableHeaders";
import ToggleTableCells from "@monorepo/uikit/src/components/tableViews/ToggleTableCells.vue";
import { viewUniqKey } from "@monorepo/utils/src/variables/projectsData/inventoryView/viewTitle";

export default defineComponent({
  name: "ToggleTableCellsContainer",
  components: {
    ToggleTableCells,
  },
  data() {
    return {
      viewUniqKey,
    };
  },
  computed: {
    ...mapGetters("informationSecurityJournal", ["cells"]),
    headers(): typeof tableHeaders {
      return tableHeaders;
    },
  },
  methods: {
    ...mapActions("informationSecurityJournal", ["setCells"]),
  },
});
